import { Anchor, Banner, CloseButton } from '@zillow/constellation-10';

export type NewMessageNotificationBannerProps = {
  /**
   * Callback function when the action button is clicked
   */
  onActionClick: () => void;
  /**
   * Callback function when the close button is clicked
   */
  onClose: () => void;
};

/**
 * A notification banner that appears at the top of the message list
 * to alert users about new messages with an action button to view them.
 */
export default function NewMessageNotificationBanner({ onActionClick, onClose }: NewMessageNotificationBannerProps) {
  return (
    <Banner.Root tone="info" onClose={onClose}>
      <Banner.Body>
        You have new messages.
        <Anchor asChild onImpact css={{ marginLeft: 'tighter' }}>
          <button type="button" onClick={onActionClick}>
            Click to view
          </button>
        </Anchor>
      </Banner.Body>
      <Banner.Close asChild>
        <CloseButton onImpact />
      </Banner.Close>
    </Banner.Root>
  );
}
